const redirects = {
  '/': '/dashboard',
  '/signup': '/dashboard/signup',
  '/template/how-to-use-brainsquall': '/board/1YQdJNDdOG',
};

export default redirects;
